import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getVenueTemplateById } from '@go-client/lib/api/venueTemplate';
import { ObjectId } from 'bson';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const VenueLog: React.FC<UserActionLog> = ({ body }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (body.template) {
          const fakePropertyId = new ObjectId().toString();
          const template = await getVenueTemplateById(fakePropertyId, body.template);
          const propertyFields = FieldsReplacer(template, logFields, [
            {
              from: 'name',
              to: 'template',
            },
          ]);

          setLogFields({ ...logFields, ...propertyFields });
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
